export const distributionContentKeys = {
  raw: (id: string) => `getDistributionContent-${id}`,
  media: (id: string) => `getDistributionContent-media-${id}`,
};
